import { zodResolver } from '@hookform/resolvers/zod'
import { useStore } from 'effector-react'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Element } from 'react-scroll'
import { FormButtons, formButtonsModel, FormProvider } from '~/shared/ui/Form'
import { BasicInfo } from './BasicInfo'
import { CarFilters } from './CarFilters'
import { DriverFilters } from './DriverFilters'
import { formSchema, FormValues } from './model'

export type FormProps = {
  isCreating?: boolean
  canEdit?: boolean
  isSubmitting?: boolean
  isLoading?: boolean
  onSuccess?: (formValues: FormValues) => void
  defaultValues?: Partial<FormValues>
}

export function Form({
  isCreating,
  canEdit,
  isSubmitting,
  isLoading,
  defaultValues,
  onSuccess,
}: FormProps) {
  const isEditing = useStore(formButtonsModel.$isEditing)
  const disabled = (!isEditing && !isCreating) || isSubmitting

  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues,
  })

  const { reset, watch } = form

  const isPromotion = watch('isPromotion')

  useEffect(() => {
    if (defaultValues) reset(defaultValues)
    // eslint-disable-next-line
  }, [defaultValues, isEditing])

  return (
    <FormProvider form={form} onSuccess={onSuccess} canEdit={canEdit}>
      <Element name='basicInfo'>
        <BasicInfo
          disabled={disabled}
          skeletonShow={isLoading}
          isPromotion={isPromotion}
        />
      </Element>
      <Element name='carFilters'>
        <CarFilters
          disabled={disabled}
          skeletonShow={isLoading}
          isPromotion={isPromotion}
        />
      </Element>
      <Element name='driverFilters'>
        <DriverFilters
          disabled={disabled}
          skeletonShow={isLoading}
          isPromotion={isPromotion}
        />
      </Element>
      <FormButtons loading={isSubmitting} isCreating={isCreating} />
    </FormProvider>
  )
}
